<div class="hotelDescription" *ngIf="hotelDscription">
  <h5 class="property__heading">Learn more about this property</h5>
  <p *ngIf="!isMobile()">{{ hotelDscription.description.replace("/\n/g", "") }}</p>
  <p *ngIf="isMobile()">{{ hotelDscription.description | slice: 0:120 }}<span id="dots2">...</span>
    <span id="more2" *ngIf="isMobile()">{{ hotelDscription.description | slice: 120:end }}</span>
  </p>
</div>

<button class="show__more-info" *ngIf="isMobile()" (click)="triggerMenu(true)" id="myBtn2">
  Read more
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.12598 1.74803L6.08011 6.18634L1.12598 10.748" stroke="#2C6DA9" stroke-width="2" />
  </svg>
</button>

<div id="md-modalDescription" class="md-modal md-effect-12">
  <div class="md-content">
    <div>
      <button type="button" title="Close Button" (click)="triggerMenu(false)" class="md-close">
        <svg width="23" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M.483.483a1.642 1.642 0 0 1 2.325 0L11.5 9.178 20.192.483a1.644 1.644 0 1 1 2.326 2.325L13.823 11.5l8.695 8.692a1.643 1.643 0 1 1-2.326 2.326L11.5 13.823l-8.692 8.695a1.644 1.644 0 1 1-2.325-2.326L9.178 11.5.483 2.808a1.642 1.642 0 0 1 0-2.325Z"/>
        </svg>
      </button>
      <div *ngIf="hotelDscription" class="modal__title-container flex-col ai-c jc-c">
        <h6 class="modal__subtitle">The Story Behind</h6>
        <h4 class="modal__title">{{ hotelDscription.name }}</h4>
      </div>

      <img *ngIf="hotelDscription" class="modal__image" [src]="hotelDscription.image" alt="" />

      <p *ngIf="isMobile() && hotelDscription" class="modal__description">
        {{ hotelDscription.description }}
      </p>

      <div class="divider-horizontal--light-blue-2"></div>

      <div class="hotelStaffWrapper">
        <div class="hotelLanguages" *ngIf="hotelDscription && hotelDscription.languages.length > 0">
          <h5 class="hotel-heading">Languages</h5>
          <ul class="lang-list">
            <li *ngFor="let language of hotelDscription.languages">
              {{ language }}
            </li>
          </ul>
        </div>
      </div>
      <div class="hotelLocation" *ngIf="locations" [ngStyle]="
          locations.shopping.size == 0 &&
          locations.healthCenters.size == 0 &&
          locations.transportation.size == 0 &&
          locations.culture.size == 0 &&
          locations.landmarks.size == 0 &&
          locations.emergencyStations.size == 0 &&
          locations.nearby.size == 0
            ? { display: 'none' }
            : {}
        ">

        <div class="divider-horizontal--light-blue-2"></div>

        <h5 class="hotel-heading">Points of Interest</h5>

        <div class="location flex-col gap-2">

          <div class="location__column flex gap-1" *ngIf="locations.shopping.size > 0">
            <img class="location__icon" src="../../../../../assets/img/icons/check-in.svg" alt="">
            <div class="flex-col gap-1">
              <h3 class="location__heading">Shopping and Dining</h3>
              <div class="location__item" *ngFor="let location of getKeys(locations.shopping)">
                <h5 class="location__subheading">{{ location }}</h5>
                <ul class="location__list flex-col gap-05">
                  <li class="location__list-item" *ngFor="let place of locations.shopping.get(location)">
                    {{ place }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="location__column flex gap-1" *ngIf="locations.healthCenters.size > 0">
            <img class="location__icon" src="../../../../../assets/img/icons/check-in.svg" alt="">
            <div class="flex-col gap-1">
              <h3 class="location__heading">Health Centers</h3>
              <div class="location__item" *ngFor="let location of getKeys(locations.healthCenters)">
                <h5 class="location__subheading">{{ location }}</h5>
                <ul class="location__list flex-col gap-05">
                  <li class="location__list-item" *ngFor="let place of locations.healthCenters.get(location)">
                    {{ place }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="location__column flex gap-1" *ngIf="locations.transportation.size > 0">
            <img class="location__icon" src="../../../../../assets/img/icons/check-in.svg" alt="">
            <div class="flex-col gap-1">
              <h3 class="location__heading">Transportation</h3>
              <div class="location__item" *ngFor="let location of getKeys(locations.transportation)">
                <h5 class="location__subheading">{{ location }}</h5>
                <ul class="location__list flex-col gap-05">
                  <li class="location__list-item" *ngFor="let place of locations.transportation.get(location)">
                    {{ place }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="location__column flex gap-1" *ngIf="locations.culture.size > 0">
            <img class="location__icon" src="../../../../../assets/img/icons/check-in.svg" alt="">
            <div class="flex-col gap-1">
              <h3 class="location__heading">Culture</h3>
              <div class="location__item" *ngFor="let location of getKeys(locations.culture)">
                <h5 class="location__subheading">{{ location }}</h5>
                <ul class="location__list flex-col gap-05">
                  <li class="location__list-item" *ngFor="let place of locations.culture.get(location)">
                    {{ place }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="location__column flex gap-1" *ngIf="locations.landmarks.size > 0">
            <img class="location__icon" src="../../../../../assets/img/icons/check-in.svg" alt="">
            <div class="flex-col gap-1">
              <h3 class="location__heading">Landmarks</h3>
              <div class="location__item" *ngFor="let location of getKeys(locations.landmarks)">
                <h5 class="location__subheading">{{ location }}</h5>
                <ul class="location__list flex-col gap-05">
                  <li class="location__list-item" *ngFor="let place of locations.landmarks.get(location)">
                    {{ place }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="location__column flex gap-1" *ngIf="locations.emergencyStations.size > 0">
            <img class="location__icon" src="../../../../../assets/img/icons/check-in.svg" alt="">
            <div class="flex-col gap-1">
              <h3 class="location__heading">Emergency Stations</h3>
              <div class="location__item" *ngFor="let location of getKeys(locations.emergencyStations)">
                <h5 class="location__subheading">{{ location }}</h5>
                <ul class="location__list flex-col gap-05">
                  <li class="location__list-item" *ngFor="let place of locations.emergencyStations.get(location)">
                    {{ place }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="location__column flex gap-1" *ngIf="locations.nearby.size > 0">
            <img class="location__icon" src="../../../../../assets/img/icons/check-in.svg" alt="">
            <div class="flex-col gap-1">
              <h3 class="location__heading">Near By</h3>
              <div class="location__item" *ngFor="let location of getKeys(locations.nearby)">
                <h5 class="location__subheading">{{ location }}</h5>
                <ul class="location__list flex-col gap-05">
                  <li class="location__list-item" *ngFor="let place of locations.nearby.get(location)">
                    {{ place }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>